/* global google */
/* global jQuery */
const moment = require('moment-timezone');
const util = require('util');

angular.module('app.orders', ['ngRoute', 'ngResource', 'angular-jwt', 'ngFileUpload', 'bw.paging', 'uiGmapgoogle-maps'])
.config(['$routeProvider', ($routeProvider) => {
  $routeProvider.when('/orders/direct', {
    template: require('./direct.html'),
    controller: 'orderListCtrl',
  })
  .when('/orders/all', {
    template: require('./direct.html'),
    controller: 'orderListCtrl',
  })
  .when('/orders/wash', {
    template: require('./direct.html'),
    controller: 'orderListCtrl',
  })  
  .when('/orders/reserve', {
    template: require('./direct.html'),
    controller: 'orderListCtrl',
  })
  .when('/orders/group/delivery', {
    template: require('./group.html'),
    controller: 'orderGroupListCtrl',
  })
  .when('/orders/group/wash', {
    template: require('./group.html'),
    controller: 'orderGroupListCtrl',
  })
  .when('/orders/group/direct', {
    template: require('./group.html'),
    controller: 'orderGroupListCtrl',
  })
  .when('/orders/group/reserve', {
    template: require('./group.html'),
    controller: 'orderGroupListCtrl',
  })
  .when('/orders/:type/add', {
    template: require('./add.html'),
    controller: 'orderAddCtrl',
  })
  .when('/orders/reserve/add/repeat', {
    template: require('./add_repeat.html'),
    controller: 'orderAddRepeatCtrl',
  })
  .when('/orders/:type/:order_no', {
    template: require('./modify.html'),
    controller: 'orderModifyCtrl',
  })
  .when('/orders/:type/:order_no/:user_id', {
    template: require('./modify.html'),
    controller: 'orderModifyCtrl',
  });
}])
.controller('orderListCtrl', ($rootScope, $translate, $scope, $resource, $route, $location, $cookies, $window, $filter, AuthService, envService, CenterInfo) => {
  $rootScope.mainmenu = 'orders';
  if ($location.path() === '/orders/direct') {
    $rootScope.menu = 'direct';
    $scope.orderType = 0;
  } else if ($location.path() === '/orders/all') {
    $rootScope.menu = 'all';
    $scope.orderType = -1;
  } else if ($location.path() === '/orders/wash') {
    $rootScope.menu = 'wash';
    $scope.orderType = -1;
  } else if ($location.path() === '/orders/reserve') {
    $rootScope.menu = 'reserve';
    $scope.orderType = 1;
  }
  const APIURL = envService.read('apiUrl');
  if (!AuthService.isAuthenticated()) {
    $location.path('/login');
    return;
  }
  $scope.isLoading = true;
  $scope.query = '';
  $scope.target_employee = '-1';
  $scope.isSearching = false;
  // Wash-count page deep-links: #/orders/...?date=&employee=&status=
  const listQuery = $location.search() || {};
  if (listQuery.date) {
    $scope.target_date = listQuery.date;
  }
  if (listQuery.employee) {
    $scope.target_employee = String(listQuery.employee);
  }
  $resource(`${APIURL}/admin/maps/center`).get((data) => {
    CenterInfo.updateCenter(data.center.latitude, data.center.longitude);
  });
  if (!$scope.target_date) {
    $scope.target_date = moment().format('YYYY-MM-DD');
  }
  $scope.paging = (page) => {
    $scope.target_page = page;
    let status;
    if ($scope.target_status !== 'none') {
      status = $scope.target_status;
    }
    $scope.isSearching = ($scope.query.length >= 1);
    const payload = { page: page - 1, q: $scope.query, queryOrderNo: $scope.queryOrderNo, queryUserName: $scope.queryUserName, queryGoods: $scope.queryGoods, queryOption: $scope.queryOption, queryEmployee: $scope.queryEmployee, queryDateStart: $scope.queryDateStart, queryDateEnd: $scope.queryDateEnd, queryGoodsOptionAndOr: $scope.queryGoodsOptionAndOr, type: $scope.orderType, target_date: $scope.target_date, status, tb_user_id_employee: $scope.target_employee, order: $scope.order, timezone: moment.tz.guess() };
    $scope.isLoading = true;
    $resource(`${APIURL}/admin/orders`).get(payload, (data) => {
      $scope.orders = data.orders;
      $scope.total_count = data.total_count;
      $scope.dates = data.dates;
      $scope.employees = data.employees;
      $scope.statuses = data.statuses;
      $scope.isLoading = false;
      jQuery('#inputPicker').val($scope.target_date);
    }, (err) => {
      $scope.isLoading = false;
      console.error(err);
      if (err.data && err.data.msg) {
        alert(err.data.msg);
      } else {
        alert($translate.instant('알수 없는 에러 입니다.'));
      }
    });
  };
  $scope.onDatePick = () => {
    $scope.target_date = jQuery('#inputPicker').val();
    $scope.paging(1);
  };

  $scope.cancelOrder = (order, cancelPayment) => {
    const msg = $translate.instant('취소 사유를 입력해주세요.');
    const cancelComment = $window.prompt(msg);
    if (cancelComment === null || cancelComment === undefined || cancelComment.length < 1) {
      alert($translate.instant('취소 사유를 입력해주세요.'));
      return;
    }
    const pushMessage = handlePushMessage($scope.cancelPayload);
    if (pushMessage < 1) {
      alert($translate.instant('메세지를 입력해주세요.'));
      return;
    }
    $resource(`${APIURL}/admin/orders/:order_no/cancel`, { order_no: order.ORDER_NO }).save({
      COMMENT: cancelComment,
      CANCEL_PAYMENT: cancelPayment,
      PUSH_MESSAGE: pushMessage,
      PAY_5000: $scope.cancelPayload.PAY_5000,
      NO_SHOW_YN: $scope.cancelPayload.MESSAGE_TYPE === '1' ? 'Y' : 'N',
    },
    () => {
      alert($translate.instant('취소되었습니다.'));
      order.STATUS = '98';
      order.STATUS_NAME = $translate.instant('세차취소(서버)');
      order.CANCEL_COMMENT = cancelComment;
      $scope.paging($scope.target_page);
    }, (err) => {
      console.error(err);
      if (err.data && err.data.msg) {
        alert(err.data.msg);
      } else {
        alert($translate.instant('알수 없는 에러 입니다.'));
      }
    });
  };

  $scope.refundByCoupon = (order) => {
    const msg = $translate.instant('취소 사유를 입력해주세요.');
    const cancelComment = $window.prompt(msg);
    if (cancelComment === null || cancelComment === undefined || cancelComment.length < 1) {
      alert($translate.instant('취소 사유를 입력해주세요.'));
      return;
    }
    $resource(`${APIURL}/admin/orders/:orderNo/refund`, { orderNo: order.ORDER_NO }).save({
      CANCEL_COMMENT: cancelComment,
    }, () => {
      alert($translate.instant('취소되었습니다.'));
      order.STATUS = '98';
      order.STATUS_NAME = $translate.instant('세차취소(서버)');
      order.CANCEL_COMMENT = cancelComment;
    }, (err) => {
      console.error(err);
      if (err.data && err.data.msg) {
        alert(err.data.msg);
      } else {
        alert($translate.instant('알수 없는 에러 입니다.'));
      }
    });
  };

  $scope.minuteFromSecond = function _(second) {
    const minute = Math.round(second / 60);
    if (!minute) {
      return '-';
    }
    return minute;
  };
  $scope.view = (order) => {
    $scope.targetOrder = order;
    $resource(`${APIURL}/admin/orders/${order.ORDER_NO}`).get({}, (data) => {
      $scope.targetOrder = data.order;
      $scope.cancelPayload = { MESSAGE_TYPE: '0', PUSH_MESSAGE: '', PAY_5000: 'N' };
      jQuery('#modal-1').modal('show');
    }, (err) => {
      console.error(err);
      if (err.data && err.data.msg) {
        alert(err.data.msg);
      } else {
        alert($translate.instant('알수 없는 에러 입니다.'));
      }
    });
  };
  $scope.viewCancelReasons = (orderNo, isConfirmedCancelRequest) => {
    $scope.reasons = [];
    if (isConfirmedCancelRequest) {
      $resource(`${APIURL}/admin/orders/cancel/request/reason/${orderNo}`).get({}).$promise
        .then((data) => {
          const reason = data.reason;
          if (reason.TYPE === '01') {
            reason.REASON = `${$translate.instant('기타')} (${reason.DESCRIPTION})`;
          }
          $scope.reasons.push(data.reason);
          jQuery('#modal-cancel-reasons').modal('show');
        })
        .catch((err) => {
          if (err.data && err.data.msg) {
            alert(err.data.msg);
          } else {
            alert($translate.instant('알수 없는 에러 입니다.'));
          }
        });
    } else {
      $resource(`${APIURL}/admin/reasons/reserve/cancel/${orderNo}`).get({}).$promise
        .then((data) => {
          $scope.reasons = data.reasons;
          jQuery('#modal-cancel-reasons').modal('show');
        })
        .catch((err) => {
          if (err.data && err.data.msg) {
            alert(err.data.msg);
          } else {
            alert($translate.instant('알수 없는 에러 입니다.'));
          }
        });
    }
  };
  $scope.viewAdminNote = (order) => {
    $scope.adminNoteEdit = '';
    $scope.targetOrder = order;
    if (order.ADMIN_NOTE) {
      $scope.adminNoteEdit = order.ADMIN_NOTE;
    }
    jQuery('#modal-admin-note').modal('show');
  };
  $scope.viewUser = (tbUserId) => {
    $resource(`${APIURL}/admin/users/:tb_user_id`, { tb_user_id: tbUserId }).get().$promise
      .then((data) => {
        if (data.user.NAME === undefined) {
          $scope.user = { NAME: $translate.instant('탈퇴한 회원입니다.') };
        } else {
          $scope.user = data.user;
        }
        $scope.isUserOnPayOnSiteBlacklist = data.isUserOnPayOnSiteBlacklist;
        jQuery('#modal-point').removeClass('fade');
        jQuery('#modal-point').modal('hide');
        jQuery('#modal-view-user').modal('show');
      })
      .catch((err) => {
        if (err.data && err.data.msg) {
          alert(err.data.msg);
        } else {
          alert($translate.instant('알수 없는 에러 입니다.'));
        }
      });
  };
  $scope.addPoint = () => {
    $scope.newpoint = { PRICE: 50000 };
    jQuery('#modal-view-user').removeClass('fade');
    jQuery('#modal-view-user').modal('hide');
    jQuery('#modal-point').modal('show');
  };
  $scope.addPointSubmit = () => {
    if ($scope.newpoint.PRICE === undefined) {
      alert($translate.instant('포인트를 입력해주세요.'));
      return;
    }
    if (isNaN(parseInt($scope.newpoint.PRICE, 10))) {
      alert($translate.instant('포인트를 입력해주세요.'));
      return;
    }
    $resource(`${APIURL}/admin/users/${$scope.user.ID}/mileage/${$scope.newpoint.PRICE}`).save($scope.newpoint,
      () => {
        alert($translate.instant('포인트가 적립되었습니다.', { price: $scope.newpoint.PRICE }));
        $scope.user.MILEAGE = parseInt($scope.user.MILEAGE, 10) + parseInt($scope.newpoint.PRICE, 10);
        $scope.paging($scope.target_page);
        jQuery('#modal-point').modal('hide');
        $scope.viewUser($scope.user.ID);
      }, (err) => {
        console.error(err);
        if (err.data && err.data.msg) {
          alert(err.data.msg);
        } else {
          alert($translate.instant('알수 없는 에러 입니다.'));
        }
      });
  };
  $scope.moveToWashHistory = (user) => {
    jQuery('#modal-view-user').removeClass('fade');
    jQuery('#modal-view-user').modal('hide');
    $location.path(`/member/${user.ID}/wash/history`);
  };
  $scope.registBlacklist = (user) => {
    const comment = $window.prompt($translate.instant('블랙리스트 등록 사유를 입력해주세요.'));
    if (!comment) {
      return;
    }
    if (comment.length < 1) {
      alert($translate.instant('블랙리스트 등록 사유를 입력해주세요.'));
      return;
    }
    $resource(`${APIURL}/admin/user/blacklist/payonsite`).save({ TB_USER_ID: user.ID, COMMENT: comment }).$promise
      .then(() => {
        alert($translate.instant('등록되었습니다.'));
        jQuery('#modal-view-user').modal('hide');
      })
      .catch((err) => {
        if (err.data && err.data.msg) {
          alert(err.data.msg);
        } else {
          alert($translate.instant('알수 없는 에러 입니다.'));
        }
      });
  };
  $scope.unregistBlacklist = (user) => {
    $resource(`${envService.read('apiUrl')}/admin/user/blacklist/payonsite/${user.ID}`).delete().$promise
      .then(() => {
        alert($translate.instant('해제되었습니다.'));
        jQuery('#modal-view-user').modal('hide');
      })
      .catch((err) => {
        if (err.data && err.data.msg) {
          alert(err.data.msg);
        } else {
          alert($translate.instant('알수 없는 에러 입니다.'));
        }
      });
  };
  $scope.submitAdminNote = () => {
    $resource(`${APIURL}/admin/orders/${$scope.targetOrder.ORDER_NO}/note`).save({ ADMIN_NOTE: $scope.adminNoteEdit }).$promise
      .then(() => {
        jQuery('#modal-admin-note').modal('hide');
        $scope.targetOrder.ADMIN_NOTE = $scope.adminNoteEdit;
      })
      .catch((err) => {
        if (err.data && err.data.msg) {
          alert(err.data.msg);
        } else {
          alert($translate.instant('알수 없는 에러 입니다.'));
        }
      });
  };
  $scope.isCanceled = (order) => {
    if (!order || !order.STATUS) { return false; }
    const status = parseInt(order.STATUS, 10);
    if (status >= 96 && status <= 99 && status !== 97) {
      return true;
    }
    return false;
  };
  $scope.movePrevDate = () => {
    const prevMoment = moment($scope.target_date, 'YYYY-MM-DD').add(-1, 'days');
    $scope.target_date = prevMoment.format('YYYY-MM-DD');
    $scope.paging(1);
  };
  $scope.moveNextDate = () => {
    const prevMoment = moment($scope.target_date, 'YYYY-MM-DD').add(1, 'days');
    $scope.target_date = prevMoment.format('YYYY-MM-DD');
    $scope.paging(1);
  };
  $scope.edit = (order) => {
    jQuery('#modal-1').removeClass('fade');
    jQuery('#modal-1').modal('hide');
    $location.path(`/orders/${$scope.menu}/${order.ORDER_NO}`);
  };
  $scope.editGoodsAndOption = (order) => {
    jQuery('#modal-1').removeClass('fade');
    jQuery('#modal-1').modal('hide');
    $location.path(`/modify/orders/${order.ORDER_NO}/goodsAndOptions`);
  };
  $scope.orderbyname = () => {
    if ($scope.order === 'USER_ASC') {
      $scope.order = 'USER_DESC';
    } else {
      $scope.order = 'USER_ASC';
    }
    $scope.paging($scope.target_page);
  };
  $scope.orderbydate = () => {
    if ($scope.order === 'ORDER_START_DATE_ASC') {
      $scope.order = 'ORDER_START_DATE_DESC';
    } else {
      $scope.order = 'ORDER_START_DATE_ASC';
    }
    $scope.paging($scope.target_page);
  };
  $scope.total_count = 0;
  $scope.query = '';
  $scope.target_status = 'none';
  if (listQuery.status) {
    $scope.target_status = String(listQuery.status);
  }
  $scope.paging(1);
})
.controller('orderGroupListCtrl', ($rootScope, $translate, $scope, $resource, $route, $location, $cookies, $window, $filter, AuthService, envService, CenterInfo) => {
  $rootScope.mainmenu = 'orders';
  if ($location.path() === '/orders/group/direct') {
    $rootScope.menu = 'direct';
    $scope.orderType = 0;
    $scope.jobType = 'W';
  } else if ($location.path() === '/orders/group/wash') {
    $rootScope.menu = 'wash';
    $scope.orderType = -1;
    $scope.jobType = 'W';
  } else if ($location.path() === '/orders/group/reserve') {
    $rootScope.menu = 'reserve';
    $scope.orderType = 1;
    $scope.jobType = 'W';
  } else if ($location.path() === '/orders/group/delivery') {
    $rootScope.menu = 'delivery';
    $scope.orderType = -1;
    $scope.jobType = 'D';
  }



  const APIURL = envService.read('apiUrl');
  if (!AuthService.isAuthenticated()) {
    $location.path('/login');
    return;
  }
  $scope.isLoading = true;
  $scope.query = '';
  $scope.target_employee = '-1';
  $scope.targetPage = { none: 0, RESERVED: 0, BEFORE: 0, ING: 0, COMPLETED: 0, CANCELED: 0 };
  $scope.isSearching = false;
  $resource(`${APIURL}/admin/maps/center`).get((data) => {
    CenterInfo.updateCenter(data.center.latitude, data.center.longitude);
  });
  if (!$scope.target_date) {
    $scope.target_date = moment().format('YYYY-MM-DD');
  }
  $scope.orders = {};

  const promiseOrder = function _(page, status) {
    return new Promise((resolve, reject) => {
      $scope.isLoading = true;
      $resource(`${APIURL}/admin/orders/group`)
        .get({ page, q: $scope.query, queryGoods: $scope.queryGoods, queryOption: $scope.queryOption, queryEmployee: $scope.queryEmployee, queryDate: $scope.queryDate, queryGoodsOptionAndOr: $scope.queryGoodsOptionAndOr, type: $scope.orderType, target_date: $scope.target_date, status, tb_user_id_employee: $scope.target_employee, order: $scope.order, timezone: moment.tz.guess(), jobType: $scope.jobType }).$promise
        .then((data) => {
          $scope.isLoading = false;
          $scope.orders[status] = data.orders;
          $scope.totalCount[status] = data.total_count;
          $scope.dates = data.dates;
          $scope.employees = data.employees;
          $scope.statuses = data.statuses;
          resolve();
        })
        .catch((err) => {
          $scope.isLoading = false;
          reject(err);
        });
    });
  };

  const promiseAll = function _() {
    Promise.all([promiseOrder(1, 'RESERVED'), promiseOrder(1, 'BEFORE'), promiseOrder(1, 'ING'), promiseOrder(1, 'COMPLETED'), promiseOrder(1, 'CANCELED')])
      .then(() => {
        $scope.targetPage = { none: 1, RESERVED: 1, BEFORE: 1, ING: 1, COMPLETED: 1, CANCELED: 1 };
        jQuery('#inputPicker').val($scope.target_date);
      })
      .catch((err) => {
        console.error(err);
        if (err.data && err.data.msg) {
          alert(err.data.msg);
        } else {
          alert($translate.instant('알수 없는 에러 입니다.'));
        }
      });
  };

  $scope.paging = (page, status) => {
    $scope.isSearching = ($scope.query.length >= 1);
    if (status) {
      $scope.targetPage[status] = page;
    } else {
      promiseAll();
      return;
    }
    const promise = promiseOrder(page, status);
    if (!promise) { return; }
    Promise.all([promise])
      .then(() => {
        jQuery('#inputPicker').val($scope.target_date);
      })
      .catch((err) => {
        console.error(err);
        if (err.data && err.data.msg) {
          alert(err.data.msg);
        } else {
          alert($translate.instant('알수 없는 에러 입니다.'));
        }
      });
  };
  $scope.onDatePick = () => {
    $scope.target_date = jQuery('#inputPicker').val();
    promiseAll();
  };

  $scope.cancelOrder = (order, cancelPayment) => {
    const msg = $translate.instant('취소 사유를 입력해주세요.');
    const cancelComment = $window.prompt(msg);
    if (cancelComment === null || cancelComment === undefined || cancelComment.length < 1) {
      alert($translate.instant('취소 사유를 입력해주세요.'));
      return;
    }

    const pushMessage = handlePushMessage($scope.cancelPayload);
    if (pushMessage < 1) {
      alert($translate.instant('메세지를 입력해주세요.'));
      return;
    }

    $resource(`${APIURL}/admin/orders/:order_no/cancel`, { order_no: order.ORDER_NO }).save({
      COMMENT: cancelComment,
      CANCEL_PAYMENT: cancelPayment,
      PUSH_MESSAGE: pushMessage,
      PAY_5000: $scope.cancelPayload.PAY_5000,
      NO_SHOW_YN: $scope.cancelPayload.MESSAGE_TYPE === '1' ? 'Y' : 'N',
    },
    () => {
      alert($translate.instant('취소되었습니다.'));
      order.STATUS = '98';
      order.STATUS_NAME = $translate.instant('세차취소(서버)');
      order.CANCEL_COMMENT = cancelComment;
      promiseAll();
    }, (err) => {
      console.error(err);
      if (err.data && err.data.msg) {
        alert(err.data.msg);
      } else {
        alert($translate.instant('알수 없는 에러 입니다.'));
      }
    });
  };

  $scope.refundByCoupon = (order) => {
    const msg = $translate.instant('취소 사유를 입력해주세요.');
    const cancelComment = $window.prompt(msg);
    if (cancelComment === null || cancelComment === undefined || cancelComment.length < 1) {
      alert($translate.instant('취소 사유를 입력해주세요.'));
      return;
    }
    $resource(`${APIURL}/admin/orders/:orderNo/refund`, { orderNo: order.ORDER_NO }).save({
      CANCEL_COMMENT: cancelComment,
    }, () => {
      alert($translate.instant('취소되었습니다.'));
      order.STATUS = '98';
      order.STATUS_NAME = $translate.instant('세차취소(서버)');
      order.CANCEL_COMMENT = cancelComment;
      promiseAll();
    }, (err) => {
      console.error(err);
      if (err.data && err.data.msg) {
        alert(err.data.msg);
      } else {
        alert($translate.instant('알수 없는 에러 입니다.'));
      }
    });
  };

  $scope.view = (order) => {
    $scope.targetOrder = order;
    $resource(`${APIURL}/admin/orders/${order.ORDER_NO}`).get({}, (data) => {
      $scope.targetOrder = data.order;
      $scope.cancelPayload = { MESSAGE_TYPE: '0', PUSH_MESSAGE: '', PAY_5000: 'N' };
      jQuery('#modal-1').modal('show');
    }, (err) => {
      console.error(err);
      if (err.data && err.data.msg) {
        alert(err.data.msg);
      } else {
        alert($translate.instant('알수 없는 에러 입니다.'));
      }
    });
  };
  $scope.viewCancelReasons = (orderNo, isConfirmedCancelRequest) => {
    $scope.reasons = [];
    if (isConfirmedCancelRequest) {
      $resource(`${APIURL}/admin/orders/cancel/request/reason/${orderNo}`).get({}).$promise
        .then((data) => {
          $scope.reasons.push(data.reason);
          jQuery('#modal-cancel-reasons').modal('show');
        })
        .catch((err) => {
          if (err.data && err.data.msg) {
            alert(err.data.msg);
          } else {
            alert($translate.instant('알수 없는 에러 입니다.'));
          }
        });
    } else {
      $resource(`${APIURL}/admin/reasons/reserve/cancel/${orderNo}`).get({}).$promise
        .then((data) => {
          $scope.reasons = data.reasons;
          jQuery('#modal-cancel-reasons').modal('show');
        })
        .catch((err) => {
          if (err.data && err.data.msg) {
            alert(err.data.msg);
          } else {
            alert($translate.instant('알수 없는 에러 입니다.'));
          }
        });
    }
  };
  $scope.viewAdminNote = (order) => {
    $scope.adminNoteEdit = '';
    $scope.targetOrder = order;
    if (order.ADMIN_NOTE) {
      $scope.adminNoteEdit = order.ADMIN_NOTE;
    }
    jQuery('#modal-admin-note').modal('show');
  };
  $scope.viewUser = (tbUserId) => {
    $resource(`${APIURL}/admin/users/:tb_user_id`, { tb_user_id: tbUserId }).get().$promise
      .then((data) => {
        if (data.user.NAME === undefined) {
          $scope.user = { NAME: $translate.instant('탈퇴한 회원입니다.') };
        } else {
          $scope.user = data.user;
        }
        $scope.isUserOnPayOnSiteBlacklist = data.isUserOnPayOnSiteBlacklist;
        jQuery('#modal-point').removeClass('fade');
        jQuery('#modal-point').modal('hide');
        jQuery('#modal-view-user').modal('show');
      })
      .catch((err) => {
        if (err.data && err.data.msg) {
          alert(err.data.msg);
        } else {
          alert($translate.instant('알수 없는 에러 입니다.'));
        }
      });
  };
  $scope.addPoint = () => {
    $scope.newpoint = { PRICE: 50000 };
    jQuery('#modal-view-user').removeClass('fade');
    jQuery('#modal-view-user').modal('hide');
    jQuery('#modal-point').modal('show');
  };
  $scope.addPointSubmit = () => {
    if ($scope.newpoint.PRICE === undefined) {
      alert($translate.instant('포인트를 입력해주세요.'));
      return;
    }
    if (isNaN(parseInt($scope.newpoint.PRICE, 10))) {
      alert($translate.instant('포인트를 입력해주세요.'));
      return;
    }
    $resource(`${APIURL}/admin/users/${$scope.user.ID}/mileage/${$scope.newpoint.PRICE}`).save($scope.newpoint,
      () => {
        alert($translate.instant('포인트가 적립되었습니다.', { price: $scope.newpoint.PRICE }));
        $scope.user.MILEAGE = parseInt($scope.user.MILEAGE, 10) + parseInt($scope.newpoint.PRICE, 10);
        $scope.paging($scope.target_page);
        jQuery('#modal-point').modal('hide');
        $scope.viewUser($scope.user.ID);
      }, (err) => {
        console.error(err);
        if (err.data && err.data.msg) {
          alert(err.data.msg);
        } else {
          alert($translate.instant('알수 없는 에러 입니다.'));
        }
      });
  };
  $scope.moveToWashHistory = (user) => {
    jQuery('#modal-view-user').removeClass('fade');
    jQuery('#modal-view-user').modal('hide');
    $location.path(`/member/${user.ID}/wash/history`);
  };
  $scope.registBlacklist = (user) => {
    const comment = $window.prompt($translate.instant('블랙리스트 등록 사유를 입력해주세요.'));
    if (!comment) {
      return;
    }
    if (comment.length < 1) {
      alert($translate.instant('블랙리스트 등록 사유를 입력해주세요.'));
      return;
    }
    $resource(`${APIURL}/admin/user/blacklist/payonsite`).save({ TB_USER_ID: user.ID, COMMENT: comment }).$promise
      .then(() => {
        alert($translate.instant('등록되었습니다.'));
        jQuery('#modal-view-user').modal('hide');
      })
      .catch((err) => {
        if (err.data && err.data.msg) {
          alert(err.data.msg);
        } else {
          alert($translate.instant('알수 없는 에러 입니다.'));
        }
      });
  };
  $scope.unregistBlacklist = (user) => {
    $resource(`${envService.read('apiUrl')}/admin/user/blacklist/payonsite/${user.ID}`).delete().$promise
      .then(() => {
        alert($translate.instant('해제되었습니다.'));
        jQuery('#modal-view-user').modal('hide');
      })
      .catch((err) => {
        if (err.data && err.data.msg) {
          alert(err.data.msg);
        } else {
          alert($translate.instant('알수 없는 에러 입니다.'));
        }
      });
  };
  $scope.submitAdminNote = () => {
    $resource(`${APIURL}/admin/orders/${$scope.targetOrder.ORDER_NO}/note`).save({ ADMIN_NOTE: $scope.adminNoteEdit }).$promise
      .then(() => {
        jQuery('#modal-admin-note').modal('hide');
        $scope.targetOrder.ADMIN_NOTE = $scope.adminNoteEdit;
      })
      .catch((err) => {
        if (err.data && err.data.msg) {
          alert(err.data.msg);
        } else {
          alert($translate.instant('알수 없는 에러 입니다.'));
        }
      });
  };
  $scope.isCanceled = (order) => {
    if (!order || !order.STATUS) { return false; }
    const status = parseInt(order.STATUS, 10);
    if (status >= 96 && status <= 99 && status !== 97) {
      return true;
    }
    return false;
  };
  $scope.movePrevDate = () => {
    const prevMoment = moment($scope.target_date, 'YYYY-MM-DD').add(-1, 'days');
    $scope.target_date = prevMoment.format('YYYY-MM-DD');
    promiseAll();
  };
  $scope.moveNextDate = () => {
    const prevMoment = moment($scope.target_date, 'YYYY-MM-DD').add(1, 'days');
    $scope.target_date = prevMoment.format('YYYY-MM-DD');
    promiseAll();
  };
  $scope.edit = (order) => {
    jQuery('#modal-1').removeClass('fade');
    jQuery('#modal-1').modal('hide');
    $location.path(`/orders/${$scope.menu}/${order.ORDER_NO}`);
  };
  $scope.orderbyname = (status) => {
    if ($scope.order === 'USER_ASC') {
      $scope.order = 'USER_DESC';
    } else {
      $scope.order = 'USER_ASC';
    }
    if (!status) return;
    $scope.paging($scope.targetPage[status], status);
  };
  $scope.orderbydate = (status) => {
    if ($scope.order === 'ORDER_START_DATE_ASC') {
      $scope.order = 'ORDER_START_DATE_DESC';
    } else {
      $scope.order = 'ORDER_START_DATE_ASC';
    }
    if (!status) return;
    $scope.paging($scope.targetPage[status], status);
  };
  $scope.minuteFromSecond = function _(second) {
    const minute = Math.round(second / 60);
    if (!minute) {
      return '-';
    }
    return minute;
  };
  $scope.total_count = 0;
  $scope.query = '';
  $scope.target_status = 'none';
  $scope.target_employee = '-1';
  promiseAll();
})
.controller('orderAddCtrl', ($rootScope, $translate, $scope, $resource, $route, $routeParams, $location, $cookies, $window, AuthService, envService, uiGmapGoogleMapApi, CenterInfo) => {
  $scope.type = $routeParams.type;
  $rootScope.mainmenu = 'orders';
  $rootScope.menu = $scope.type;
  const APIURL = envService.read('apiUrl');
  if (!AuthService.isAuthenticated()) {
    $location.path('/login');
    return;
  }
  $window.scrollTo(0,0);
  $scope.countryCode = $scope.loginMember.COUNTRY_CODE;
  $scope.map = { control: {}, center: { latitude: CenterInfo.center.latitude, longitude: CenterInfo.center.longitude }, zoom: 13 };
  $scope.order = { address: '', address2: '', WASH_OUTSIDE_YN: 'N', TB_WASH_COUPON_ID: '-1', TB_PERCENT_COUPON_ID: '-1', TOTAL_PRICE: 0 };

  if ($scope.type === 'direct') {
    $scope.order.ORDER_TYPE = 0;
  } else {
    $scope.order.ORDER_TYPE = 1;
    $resource(`${APIURL}/admin/reservation/times`).get({ TIMEZONE: moment.tz.guess() }, (data) => {
      $scope.times = data.times;
      $scope.dates = [];
      $scope.hours = [];
      $scope.minutes = [];
      moment.locale($scope.locale);
      $scope.times.forEach((time) => {
        const _date = Object.keys(time)[0];
        const _dateLocale = moment(_date, 'YYYY년 MM월 DD일').format('LL');
        $scope.dates.push({ date: _date, dateLocale: _dateLocale });
      });
      $scope.order.date = Object.keys($scope.times[0])[0];
      $scope.times[0][$scope.order.date].forEach(hourDic => $scope.hours.push(Object.keys(hourDic)[0]));
      $scope.order.hour = Object.keys($scope.times[0][$scope.order.date][0])[0];
      $scope.minutes = $scope.times[0][$scope.order.date][0][$scope.order.hour];
      $scope.order.minute = `${$scope.minutes[0]}`;
    }, (err) => {
      console.error(err);
      if (err.data && err.data.msg) {
        alert(err.data.msg);
      } else {
        alert($translate.instant('알수 없는 에러 입니다.'));
      }
    });

    $scope.changeOrderDate = () => {
      let idx = 0;
      for (; idx < $scope.dates.length; idx += 1) {
        if ($scope.order.date == $scope.dates[idx].date) { // eslint-disable-line
          break;
        }
      }
      $scope.hours = [];
      $scope.minutes = [];
      $scope.times[idx][$scope.order.date].forEach(hourDic => $scope.hours.push(Object.keys(hourDic)[0]));
      $scope.order.hour = Object.keys($scope.times[idx][$scope.order.date][0])[0];
      $scope.minutes = $scope.times[idx][$scope.order.date][0][$scope.order.hour];
      $scope.order.minute = `${$scope.minutes[0]}`;
    };

    $scope.changeOrderHour = () => {
      let dateidx = 0;
      let houridx = 0;
      for (; dateidx <= $scope.dates; dateidx += 1) {
        if ($scope.order.date == $scope.dates[dateidx].date) { // eslint-disable-line
          break;
        }
      }
      for (; houridx <= $scope.hours.length; houridx += 1) {
        if ($scope.order.hour == $scope.hours[houridx]) { // eslint-disable-line
          break;
        }
      }
      $scope.minutes = $scope.times[dateidx][$scope.order.date][houridx][$scope.order.hour];
      $scope.order.minute = `${$scope.minutes[0]}`;
    };
  }

  uiGmapGoogleMapApi.then(() => {
    $resource(`${APIURL}/maps/areas`).get((data) => {
      data.areas.forEach((area) => {
        let path = area.POLYLINE;
        path = path.replace('\n', '\\n');
        const polyline = new google.maps.Polygon({
          path: google.maps.geometry.encoding.decodePath(path),
          geodesic: true,
          strokeColor: '#5694cc',
          fillColor: '#5694cc',
          strokeOpacity: 1.0,
          fillOpacity: 0.1,
          strokeWeight: 2,
        });
        polyline.setMap($scope.map.control.getGMap());
      });
      $scope.marker = new google.maps.Marker({
        position: { lat: $scope.map.center.latitude, lng: $scope.map.center.longitude },
        map: $scope.map.control.getGMap(),
      });
      $scope.updateAddress($scope.map.center.latitude, $scope.map.center.longitude);
      $scope.map.control.getGMap().addListener('drag', () => {
        $scope.marker.setPosition(new google.maps.LatLng($scope.map.control.getGMap().center.lat(), $scope.map.control.getGMap().center.lng()));
      });
      $scope.map.control.getGMap().addListener('dragend', () => {
        $scope.updateAddress($scope.map.control.getGMap().center.lat(), $scope.map.control.getGMap().center.lng());
      });
      $resource(`${APIURL}/admin/maps/center`).get((centerInfo) => {
        CenterInfo.updateCenter(centerInfo.center.latitude, centerInfo.center.longitude);
        const latLng = new google.maps.LatLng({ lat: CenterInfo.center.latitude, lng: CenterInfo.center.longitude });
        $scope.map.control.getGMap().panTo(latLng);
        $scope.marker.setPosition(latLng);
        $scope.updateAddress($scope.map.control.getGMap().center.lat(), $scope.map.control.getGMap().center.lng());
      });
    }, (err) => {
      console.error(err);
      if (err.data && err.data.msg) {
        alert(err.data.msg);
      } else {
        alert($translate.instant('알수 없는 에러 입니다.'));
      }
    });
  });
  $scope.updateAddress = (lat, lng) => {
    $resource(`${APIURL}/maps/areas/address`).get({ LAT: lat, LON: lng }, (data) => {
      $scope.order.address = data.address;
    });
  };

  // 지도 검색
  $scope.searchPlaces = () => {
    $resource(`${APIURL}/maps/google/autocomplete`).get({ q: $scope.order.address }, (data) => {
      if (data.predictions === undefined || data.predictions.length < 1) {
        alert($translate.instant('검색결과가 없습니다.'));
        return;
      }
      $scope.predictions = data.predictions;
      jQuery('#modal-3').modal('show');
    });
  };

  $scope.selectPrediction = (prediction) => {
    $resource(`${APIURL}/maps/google/${prediction.place_id}`).get((data) => {
      $scope.order.address = prediction.description;
      $scope.map.control.getGMap().setCenter(new google.maps.LatLng(data.data.geometry.location.lat, data.data.geometry.location.lng));
      $scope.marker.setPosition(new google.maps.LatLng($scope.map.control.getGMap().center.lat(), $scope.map.control.getGMap().center.lng()));
      $scope.updateAddress($scope.map.control.getGMap().center.lat(), $scope.map.control.getGMap().center.lng());
      jQuery('#modal-3').modal('hide');
    });
  };

  // 사용자 검색
  $scope.openUsers = () => {
    $scope.userSearch = { query: '', result: [] };
    jQuery('#modal-1').modal('show');
  };
  $scope.searchUsers = () => {
    $resource(`${APIURL}/admin/users`).get({ q: $scope.userSearch.query, count: -1 }, (data) => {
      $scope.userSearch.result = data.users;
    }, (err) => {
      console.error(err);
      if (err.data && err.data.msg) {
        alert(err.data.msg);
      } else {
        alert($translate.instant('알수 없는 에러 입니다.'));
      }
    });
  };
  $scope.selectUser = (user) => {
    $scope.order.user = user;
    $resource(`${APIURL}/admin/users/${user.ID}/usercars`).get({ COUNTRY_CODE: $scope.countryCode }, (data) => {
      $scope.usercars = data.usercars;
      jQuery('#modal-1').modal('hide');
    }, (err) => {
      console.error(err);
      if (err.data && err.data.msg) {
        alert(err.data.msg);
      } else {
        alert($translate.instant('알수 없는 에러 입니다.'));
      }
    });
  };

  // 테크니션 검색
  $scope.openEmployees = () => {
    $resource(`${APIURL}/admin/employees/available`).get((data) => {
      $scope.employeeSearch = { query: '', result: data.employees };
      jQuery('#modal-2').modal('show');
    }, (err) => {
      console.error(err);
      if (err.data && err.data.msg) {
        alert(err.data.msg);
      } else {
        alert($translate.instant('알수 없는 에러 입니다.'));
      }
    });
  };
  $scope.searchEmployee = () => {
    $resource(`${APIURL}/admin/employees/available`).get({ q: $scope.employeeSearch.query, count: -1 }, (data) => {
      $scope.employeeSearch.result = data.employees;
    }, (err) => {
      console.error(err);
      if (err.data && err.data.msg) {
        alert(err.data.msg);
      } else {
        alert($translate.instant('알수 없는 에러 입니다.'));
      }
    });
  };
  $scope.selectEmployee = (user) => {
    $scope.order.employee = user;
    jQuery('#modal-2').modal('hide');
  };

  // 차량 / 상품 / 옵션
  $scope.requestGoods = () => {
    let usercar = null;
    for (let idx = 0; idx <= $scope.usercars.length; idx += 1) {
      if ($scope.usercars[idx].ID == $scope.order.car.ID) { // eslint-disable-line
        usercar = $scope.usercars[idx];
        break;
      }
    }
    if (usercar === null) {
      return;
    }
    $resource(`${APIURL}/wash/goods/${usercar.GOODS_ID}`, {}, { get: {
      method: 'GET',
      headers: {
        'IW-App-Version': '5.0.0',
      },
    } }).get({ COUNTRY_CODE: $scope.countryCode, TB_USER_ID: $scope.order.user.ID }, (data) => {
      $scope.goods = data.goods;
      $scope.order.goods = {};
      $scope.order.options = {};
    }, (err) => {
      console.error(err);
      if (err.data && err.data.msg) {
        alert(err.data.msg);
      } else {
        alert($translate.instant('알수 없는 에러 입니다.'));
      }
    });
  };
  $scope.requestOptions = () => {
    $resource(`${APIURL}/wash/goods/${$scope.order.goods.ID}/options`, {}, { get: {
      method: 'GET',
      headers: {
        'IW-App-Version': '5.0.0',
      },
    } }).get({ COUNTRY_CODE: $scope.countryCode, TB_USER_ID: $scope.order.user.ID }, (data) => {
      $scope.options = data.options;
    }, (err) => {
      console.error(err);
      if (err.data && err.data.msg) {
        alert(err.data.msg);
      } else {
        alert($translate.instant('알수 없는 에러 입니다.'));
      }
    });
    $scope.updatePrice();
    const good = $scope.goods.find(_good => _good.ID == $scope.order.goods.ID);  // eslint-disable-line
    const params = {};
    if (good && good.TYPE) {
      params.productType = good.TYPE;
    }
    $resource(`${APIURL}/admin/users/${$scope.order.user.ID}/coupons/available`).get(params, (data) => {
      $scope.order.TB_WASH_COUPON_ID = '-1';
      $scope.coupons = data.coupons;
      $scope.percent_coupons = data.percent_coupons;
    }, (err) => {
      console.error(err);
      if (err.data && err.data.msg) {
        alert(err.data.msg);
      } else {
        alert($translate.instant('알수 없는 에러 입니다.'));
      }
    });
  };
  $scope.selectWashCoupon = () => {
    $scope.order.TB_PERCENT_COUPON_ID = '-1';
    $scope.updatePrice();
  };
  $scope.selectPercentCoupon = () => {
    $scope.order.TB_WASH_COUPON_ID = '-1';
    $scope.updatePrice();
  };
  $scope.updatePrice = () => {
    if (!$scope.goods) {
      return;
    }
    let goods = null;
    for (let goodsIdx = 0; goodsIdx <= $scope.goods.length; goodsIdx += 1) {
      // 두 아이디 값의 타입이 다르므로 == 사용
      if ($scope.goods[goodsIdx].ID == $scope.order.goods.ID) { // eslint-disable-line
        goods = $scope.goods[goodsIdx];
        break;
      }
    }
    if (goods === null) {
      $scope.order.TOTAL_PRICE = 0;
      return;
    }
    $scope.order.CURRENCY_SYMBOL = goods.CURRENCY_SYMBOL;
    $scope.order.TOTAL_PRICE = parseInt(goods.GOODS_PRICE, 10);

    if ($scope.options) {
      $scope.options.forEach((option) => {
        if (option.checked) {
          $scope.order.TOTAL_PRICE += parseInt(option.OPTION_PRICE, 10);
        }
      });
    }
    if ($scope.coupons) {
      $scope.coupons.forEach((coupon) => {
        if ($scope.order.TB_WASH_COUPON_ID == coupon.ID) { // eslint-disable-line
          $scope.order.TOTAL_PRICE -= parseInt(coupon.PRICE, 10);
        }
      });
    }
    if ($scope.percent_coupons) {
      $scope.percent_coupons.forEach((coupon) => {
        if ($scope.order.TB_PERCENT_COUPON_ID == coupon.ID) { // eslint-disable-line
          $scope.order.TOTAL_PRICE -= parseInt(coupon.PERCENT, 10) * 0.01 * parseInt(goods.GOODS_PRICE, 10);
        }
      });
    }

    let MILEAGE = 0;
    if ($scope.order.MILEAGE !== undefined && $scope.order.MILEAGE !== null && $scope.order.MILEAGE.length > 0) {
      MILEAGE = $scope.order.MILEAGE;
    }
    $scope.order.TOTAL_PRICE -= parseInt(MILEAGE, 10);
  };

  $scope.isLoading = false;
  $scope.submit = () => {
    if ($scope.isLoading) {
      return;
    }
    if (!$scope.order.user) {
      alert($translate.instant('주문자를 선택해주세요.'));
      return;
    }
    if (!$scope.order.employee) {
      alert($translate.instant('테크니션을 선택해주세요.'));
      return;
    }
    if (!$scope.order.address2 || $scope.order.address2.length < 1) {
      alert($translate.instant('상세주소를 입력해주세요.'));
      return;
    }

    let usercar = null;
    for (let carIdx = 0; carIdx < $scope.usercars.length; carIdx += 1) {
      if ($scope.usercars[carIdx].ID == $scope.order.car.ID) { // eslint-disable-line
        usercar = $scope.usercars[carIdx];
        break;
      }
    }
    if (usercar === null) {
      alert($translate.instant('차량을 선택해주세요.'));
      return;
    }
    let goods = null;
    for (let goodsIdx = 0; goodsIdx < $scope.goods.length; goodsIdx += 1) {
      if ($scope.goods[goodsIdx].ID == $scope.order.goods.ID) { // eslint-disable-line
        goods = $scope.goods[goodsIdx];
        break;
      }
    }
    if (goods === null) {
      alert($translate.instant('상품을 선택해주세요.'));
      return;
    }

    let MILEAGE = 0;
    if ($scope.order.MILEAGE !== undefined && $scope.order.MILEAGE !== null && $scope.order.MILEAGE.length > 0) {
      MILEAGE = $scope.order.MILEAGE;
    }

    if (isNaN(parseInt(MILEAGE, 10))) {
      alert($translate.instant('올바른 포인트를 입력해주세요.'));
      return;
    } else if ($scope.order.user.MILEAGE < MILEAGE) {
      alert(util.format($translate.instant('최대 %d 포인트까지 사용가능합니다.'), $scope.order.user.MILEAGE));
      return;
    }

    if ($scope.order.PAYMENT_METHOD === null || $scope.order.PAYMENT_METHOD === undefined) {
      alert($translate.instant('결제수단을 선택해주세요.'));
      return;
    }

    const optionCode = [];
    const optionName = [];

    $scope.options.forEach((option) => {
      if (option.checked) {
        optionCode.push(option.ID);
        optionName.push(option.OPTION_NAME);
      }
    });

    const requestAddOrder = () => {
      $scope.isLoading = true;
      $resource(`${APIURL}/admin/orders`).save({
        TB_USER_ID: $scope.order.user.ID,
        TB_USER_ID_EMPLOYEE: $scope.order.employee.ID,
        ORDER_CAR_CD: usercar.CAR_CD,
        ORDER_CAR_NAME: usercar.CAR_NAME,
        ORDER_CAR_COLOR: usercar.CAR_COLOR,
        ORDER_CAR_IMG_URL: usercar.CAR_IMG_URL,
        ORDER_CAR_NO: usercar.CAR_NO,
        ORDER_CAR_MAKER_NAME: usercar.MAKER_NAME,
        GOODS_ID: goods.GOODS_ID,
        USER_LAT: $scope.map.control.getGMap().center.lat(),
        USER_LNG: $scope.map.control.getGMap().center.lng(),
        USER_ADDR: $scope.order.address,
        USER_ADDR2: $scope.order.address2,
        TB_USER_CARINFO_ID: usercar.ID,
        ORDER_OUTSIDE_YN: $scope.order.WASH_OUTSIDE_YN,
        OPTION_CODE: optionCode,
        OPTION_NAME: optionName,
        MILEAGE,
        TB_WASH_COUPON_ID: $scope.order.TB_WASH_COUPON_ID,
        TB_PERCENT_COUPON_ID: $scope.order.TB_PERCENT_COUPON_ID,
        ORDER_TYPE: $scope.order.ORDER_TYPE,
        DATE: $scope.order.date,
        HOUR: $scope.order.hour,
        MINUTE: $scope.order.minute,
        PAYMENT_METHOD: $scope.order.PAYMENT_METHOD,
        COMMENT_USER: $scope.order.COMMENT_USER,
        TIMEZONE: moment.tz.guess(),
      }, () => {
        $scope.isLoading = false;
        alert($translate.instant('주문이 등록되었습니다.'));
        $location.path(`/orders/${$scope.menu}`);
      }, (err) => {
        $scope.isLoading = false;
        console.error(err);
        if (err.data && err.data.msg) {
          alert(err.data.msg);
        } else {
          alert($translate.instant('알수 없는 에러 입니다.'));
        }
      });
    };

    if (parseInt($scope.order.ORDER_TYPE, 10) === 1) {
      $scope.isLoading = true;
      $resource(`${APIURL}/admin/orders/reserve/check`).save({
        TB_USER_ID: $scope.order.user.ID,
        TB_USER_ID_EMPLOYEE: $scope.order.employee.ID,
        ORDER_CAR_CD: usercar.CAR_CD,
        ORDER_CAR_NAME: usercar.CAR_NAME,
        ORDER_CAR_COLOR: usercar.CAR_COLOR,
        ORDER_CAR_IMG_URL: usercar.CAR_IMG_URL,
        ORDER_CAR_NO: usercar.CAR_NO,
        ORDER_CAR_MAKER_NAME: usercar.MAKER_NAME,
        GOODS_ID: goods.GOODS_ID,
        USER_LAT: $scope.map.control.getGMap().center.lat(),
        USER_LNG: $scope.map.control.getGMap().center.lng(),
        USER_ADDR: $scope.order.address,
        USER_ADDR2: $scope.order.address2,
        TB_USER_CARINFO_ID: usercar.ID,
        ORDER_OUTSIDE_YN: $scope.order.WASH_OUTSIDE_YN,
        OPTION_CODE: optionCode,
        OPTION_NAME: optionName,
        MILEAGE,
        TB_WASH_COUPON_ID: $scope.order.TB_WASH_COUPON_ID,
        ORDER_TYPE: $scope.order.ORDER_TYPE,
        DATE: $scope.order.date,
        HOUR: $scope.order.hour,
        MINUTE: $scope.order.minute,
        PAYMENT_METHOD: $scope.order.PAYMENT_METHOD,
        COMMENT_USER: $scope.order.COMMENT_USER,
        TIMEZONE: moment.tz.guess(),
      }, () => {
        requestAddOrder();
      }, (err) => {
        console.log(err);
        $scope.isLoading = false;
        if (err.status === 409) {
          if (confirm(err.data.msg)) {
            requestAddOrder();
          }
          return;
        }
        console.error(err);
        if (err.data && err.data.msg) {
          alert(err.data.msg);
        } else {
          alert($translate.instant('알수 없는 에러 입니다.'));
        }
      });
    } else {
      requestAddOrder();
    }
  };
})
.controller('orderAddRepeatCtrl', ($rootScope, $translate, $scope, $resource, $route, $routeParams, $location, $cookies, $window, AuthService, envService, uiGmapGoogleMapApi, CenterInfo) => {
  $scope.type = $routeParams.type;
  $rootScope.mainmenu = 'orders';
  $rootScope.menu = 'reserve';
  const APIURL = envService.read('apiUrl');
  if (!AuthService.isAuthenticated()) {
    $location.path('/login');
    return;
  }
  $scope.countryCode = $scope.loginMember.COUNTRY_CODE;
  $scope.map = { control: {}, center: { latitude: CenterInfo.center.latitude, longitude: CenterInfo.center.longitude }, zoom: 13 };
  $scope.order = { address: '', address2: '', WASH_OUTSIDE_YN: 'N', TB_WASH_COUPON_ID: -1, TOTAL_PRICE: 0 };

  $scope.order.ORDER_TYPE = 1;
  $scope.order.STARTDATE = moment().format('YYYYMMDD');
  $scope.order.ENDDATE = moment().add(30, 'days').format('YYYYMMDD');
  $scope.order.HOUR = '10';
  $scope.order.MINUTE = '00';
  $scope.order.DAY_OF_WEEK = '1';
  uiGmapGoogleMapApi.then(() => {
    $resource(`${APIURL}/maps/areas`).get((data) => {
      data.areas.forEach((area) => {
        let path = area.POLYLINE;
        path = path.replace('\n', '\\n');
        const polyline = new google.maps.Polygon({
          path: google.maps.geometry.encoding.decodePath(path),
          geodesic: true,
          strokeColor: '#5694cc',
          fillColor: '#5694cc',
          strokeOpacity: 1.0,
          fillOpacity: 0.1,
          strokeWeight: 2,
        });
        polyline.setMap($scope.map.control.getGMap());
      });
      $scope.marker = new google.maps.Marker({
        position: { lat: $scope.map.center.latitude, lng: $scope.map.center.longitude },
        map: $scope.map.control.getGMap(),
      });
      $scope.updateAddress($scope.map.center.latitude, $scope.map.center.longitude);
      $scope.map.control.getGMap().addListener('drag', () => {
        $scope.marker.setPosition(new google.maps.LatLng($scope.map.control.getGMap().center.lat(), $scope.map.control.getGMap().center.lng()));
      });
      $scope.map.control.getGMap().addListener('dragend', () => {
        $scope.updateAddress($scope.map.control.getGMap().center.lat(), $scope.map.control.getGMap().center.lng());
      });
      $resource(`${APIURL}/admin/maps/center`).get((centerInfo) => {
        CenterInfo.updateCenter(centerInfo.center.latitude, centerInfo.center.longitude);
        const latLng = new google.maps.LatLng({ lat: CenterInfo.center.latitude, lng: CenterInfo.center.longitude });
        $scope.map.control.getGMap().panTo(latLng);
        $scope.marker.setPosition(latLng);
        $scope.updateAddress($scope.map.control.getGMap().center.lat(), $scope.map.control.getGMap().center.lng());
      });
    }, (err) => {
      console.error(err);
      if (err.data && err.data.msg) {
        alert(err.data.msg);
      } else {
        alert($translate.instant('알수 없는 에러 입니다.'));
      }
    });
  });
  $scope.updateAddress = (lat, lng) => {
    $resource(`${APIURL}/maps/areas/address`).get({ LAT: lat, LON: lng }, (data) => {
      $scope.order.address = data.address;
    });
  };

  // 지도 검색
  $scope.searchPlaces = () => {
    $resource(`${APIURL}/maps/google/autocomplete`).get({ q: $scope.order.address }, (data) => {
      if (data.predictions === undefined || data.predictions.length < 1) {
        alert($translate.instant('검색결과가 없습니다.'));
        return;
      }
      $scope.predictions = data.predictions;
      jQuery('#modal-3').modal('show');
    });
  };

  $scope.selectPrediction = (prediction) => {
    $resource(`${APIURL}/maps/google/${prediction.place_id}`).get((data) => {
      $scope.order.address = prediction.description;
      $scope.map.control.getGMap().setCenter(new google.maps.LatLng(data.data.geometry.location.lat, data.data.geometry.location.lng));
      $scope.marker.setPosition(new google.maps.LatLng($scope.map.control.getGMap().center.lat(), $scope.map.control.getGMap().center.lng()));
      $scope.updateAddress($scope.map.control.getGMap().center.lat(), $scope.map.control.getGMap().center.lng());
      jQuery('#modal-3').modal('hide');
    });
  };

  // 사용자 검색
  $scope.openUsers = () => {
    $scope.userSearch = { query: '', result: [] };
    jQuery('#modal-1').modal('show');
  };
  $scope.searchUsers = () => {
    $resource(`${APIURL}/admin/users`).get({ q: $scope.userSearch.query, count: -1 }, (data) => {
      $scope.userSearch.result = data.users;
    }, (err) => {
      console.error(err);
      if (err.data && err.data.msg) {
        alert(err.data.msg);
      } else {
        alert($translate.instant('알수 없는 에러 입니다.'));
      }
    });
  };
  $scope.selectUser = (user) => {
    $scope.order.user = user;
    $resource(`${APIURL}/admin/users/${user.ID}/usercars`).get({ COUNTRY_CODE: $scope.countryCode }, (data) => {
      $scope.usercars = data.usercars;
      jQuery('#modal-1').modal('hide');
    }, (err) => {
      console.error(err);
      if (err.data && err.data.msg) {
        alert(err.data.msg);
      } else {
        alert($translate.instant('알수 없는 에러 입니다.'));
      }
    });
    $resource(`${APIURL}/admin/users/${user.ID}/coupons/available`).get((data) => {
      $scope.order.TB_WASH_COUPON_ID = -1;
      $scope.coupons = data.coupons;
    }, (err) => {
      console.error(err);
      if (err.data && err.data.msg) {
        alert(err.data.msg);
      } else {
        alert($translate.instant('알수 없는 에러 입니다.'));
      }
    });
  };

  // 테크니션 검색
  $scope.openEmployees = () => {
    $resource(`${APIURL}/admin/employees/available`).get((data) => {
      $scope.employeeSearch = { query: '', result: data.employees };
      jQuery('#modal-2').modal('show');
    }, (err) => {
      console.error(err);
      if (err.data && err.data.msg) {
        alert(err.data.msg);
      } else {
        alert($translate.instant('알수 없는 에러 입니다.'));
      }
    });
  };
  $scope.searchEmployee = () => {
    $resource(`${APIURL}/admin/employees/available`).get({ q: $scope.employeeSearch.query, count: -1 }, (data) => {
      $scope.employeeSearch.result = data.employees;
    }, (err) => {
      console.error(err);
      if (err.data && err.data.msg) {
        alert(err.data.msg);
      } else {
        alert($translate.instant('알수 없는 에러 입니다.'));
      }
    });
  };
  $scope.selectEmployee = (user) => {
    $scope.order.employee = user;
    jQuery('#modal-2').modal('hide');
  };

  // 차량 / 상품 / 옵션
  $scope.requestGoods = () => {
    let usercar = null;
    for (let idx = 0; idx <= $scope.usercars.length; idx += 1) {
      if ($scope.usercars[idx].ID == $scope.order.car.ID) { // eslint-disable-line
        usercar = $scope.usercars[idx];
        break;
      }
    }
    if (usercar === null) {
      return;
    }
    $resource(`${APIURL}/wash/goods/${usercar.GOODS_ID}`, {}, { get: {
      method: 'GET',
      headers: {
        'IW-App-Version': '5.0.0',
      },
    } }).get({ COUNTRY_CODE: $scope.countryCode }, (data) => {
      $scope.goods = data.goods;
      $scope.order.goods = {};
      $scope.order.options = {};
    }, (err) => {
      console.error(err);
      if (err.data && err.data.msg) {
        alert(err.data.msg);
      } else {
        alert($translate.instant('알수 없는 에러 입니다.'));
      }
    });
  };
  $scope.requestOptions = () => {
    $resource(`${APIURL}/wash/goods/${$scope.order.goods.ID}/options`, {}, { get: {
      method: 'GET',
      headers: {
        'IW-App-Version': '5.0.0',
      },
    } }).get({ COUNTRY_CODE: $scope.countryCode }, (data) => {
      $scope.options = data.options;
    }, (err) => {
      console.error(err);
      if (err.data && err.data.msg) {
        alert(err.data.msg);
      } else {
        alert($translate.instant('알수 없는 에러 입니다.'));
      }
    });
    $scope.updatePrice();
  };
  $scope.updatePrice = () => {
    if (!$scope.goods) {
      return;
    }
    let goods = null;
    for (let goodsIdx = 0; goodsIdx <= $scope.goods.length; goodsIdx += 1) {
      // 두 아이디 값의 타입이 다르므로 == 사용
      if ($scope.goods[goodsIdx].ID == $scope.order.goods.ID) { // eslint-disable-line
        goods = $scope.goods[goodsIdx];
        break;
      }
    }
    if (goods === null) {
      $scope.order.TOTAL_PRICE = 0;
      return;
    }
    $scope.order.CURRENCY_SYMBOL = goods.CURRENCY_SYMBOL;
    $scope.order.TOTAL_PRICE = parseInt(goods.GOODS_PRICE, 10);

    if ($scope.options) {
      $scope.options.forEach((option) => {
        if (option.checked) {
          $scope.order.TOTAL_PRICE += parseInt(option.OPTION_PRICE, 10);
        }
      });
    }
    if ($scope.coupons) {
      $scope.coupons.forEach((coupon) => {
        if ($scope.order.TB_WASH_COUPON_ID == coupon.ID) { // eslint-disable-line
          $scope.order.TOTAL_PRICE -= parseInt(coupon.PRICE, 10);
        }
      });
    }

    let MILEAGE = 0;
    if ($scope.order.MILEAGE !== undefined && $scope.order.MILEAGE !== null && $scope.order.MILEAGE.length > 0) {
      MILEAGE = $scope.order.MILEAGE;
    }
    $scope.order.TOTAL_PRICE -= parseInt(MILEAGE, 10);
  };

  $scope.isLoading = false;
  $scope.submit = () => {
    if ($scope.isLoading) {
      return;
    }
    if (!$scope.order.user) {
      alert($translate.instant('주문자를 선택해주세요.'));
      return;
    }
    if (!$scope.order.employee) {
      alert($translate.instant('테크니션을 선택해주세요.'));
      return;
    }
    if (!$scope.order.address2 || $scope.order.address2.length < 1) {
      alert($translate.instant('상세주소를 입력해주세요.'));
      return;
    }

    let usercar = null;
    for (let carIdx = 0; carIdx < $scope.usercars.length; carIdx += 1) {
      if ($scope.usercars[carIdx].ID == $scope.order.car.ID) { // eslint-disable-line
        usercar = $scope.usercars[carIdx];
        break;
      }
    }
    if (usercar === null) {
      alert($translate.instant('차량을 선택해주세요.'));
      return;
    }
    let goods = null;
    for (let goodsIdx = 0; goodsIdx < $scope.goods.length; goodsIdx += 1) {
      if ($scope.goods[goodsIdx].ID == $scope.order.goods.ID) { // eslint-disable-line
        goods = $scope.goods[goodsIdx];
        break;
      }
    }
    if (goods === null) {
      alert($translate.instant('상품을 선택해주세요.'));
      return;
    }

    let MILEAGE = 0;
    if ($scope.order.MILEAGE !== undefined && $scope.order.MILEAGE !== null && $scope.order.MILEAGE.length > 0) {
      MILEAGE = $scope.order.MILEAGE;
    }

    if (isNaN(parseInt(MILEAGE, 10))) {
      alert($translate.instant('올바른 포인트를 입력해주세요.'));
      return;
    } else if ($scope.order.user.MILEAGE < MILEAGE) {
      alert(util.format($translate.instant('최대 %d 포인트까지 사용가능합니다.'), $scope.order.user.MILEAGE));
      return;
    }

    if ($scope.order.PAYMENT_METHOD === null || $scope.order.PAYMENT_METHOD === undefined) {
      alert($translate.instant('결제수단을 선택해주세요.'));
      return;
    }

    const optionCode = [];
    const optionName = [];

    $scope.options.forEach((option) => {
      if (option.checked) {
        optionCode.push(option.ID);
        optionName.push(option.OPTION_NAME);
      }
    });

    $scope.isLoading = true;
    $resource(`${APIURL}/admin/orders/reserved/repeat`).save({
      TB_USER_ID: $scope.order.user.ID,
      TB_USER_ID_EMPLOYEE: $scope.order.employee.ID,
      ORDER_CAR_CD: usercar.CAR_CD,
      ORDER_CAR_NAME: usercar.CAR_NAME,
      ORDER_CAR_COLOR: usercar.CAR_COLOR,
      ORDER_CAR_IMG_URL: usercar.CAR_IMG_URL,
      ORDER_CAR_NO: usercar.CAR_NO,
      ORDER_CAR_MAKER_NAME: usercar.MAKER_NAME,
      GOODS_ID: goods.GOODS_ID,
      USER_LAT: $scope.map.control.getGMap().center.lat(),
      USER_LNG: $scope.map.control.getGMap().center.lng(),
      USER_ADDR: $scope.order.address,
      USER_ADDR2: $scope.order.address2,
      TB_USER_CARINFO_ID: usercar.ID,
      ORDER_OUTSIDE_YN: $scope.order.WASH_OUTSIDE_YN,
      OPTION_CODE: optionCode,
      OPTION_NAME: optionName,
      MILEAGE,
      TB_WASH_COUPON_ID: $scope.order.TB_WASH_COUPON_ID,
      ORDER_TYPE: $scope.order.ORDER_TYPE,
      STARTDATE: $scope.order.STARTDATE,
      ENDDATE: $scope.order.ENDDATE,
      HOUR: $scope.order.HOUR,
      MINUTE: $scope.order.MINUTE,
      DAY_OF_WEEK: $scope.order.DAY_OF_WEEK,
      PAYMENT_METHOD: $scope.order.PAYMENT_METHOD,
      COMMENT_USER: $scope.order.COMMENT_USER,
      TIMEZONE: moment.tz.guess(),
    }, () => {
      $scope.isLoading = false;
      alert($translate.instant('주문이 등록되었습니다.'));
      $location.path('/orders/reserve');
    }, (err) => {
      $scope.isLoading = false;
      console.error(err);
      if (err.data && err.data.msg) {
        alert(err.data.msg);
      } else {
        alert($translate.instant('알수 없는 에러 입니다.'));
      }
    });
  };
})
.controller('orderModifyCtrl', ($rootScope, $translate, $scope, $resource, $route, $routeParams, $location, $cookies, $window, AuthService, envService) => {
  $scope.type = $routeParams.type;
  $scope.order_no = $routeParams.order_no;
  $scope.user_id = $routeParams.user_id;
  $rootScope.mainmenu = 'orders';
  $rootScope.menu = $scope.type;
  const APIURL = envService.read('apiUrl');
  if (!AuthService.isAuthenticated()) {
    $location.path('/login');
    return;
  }

  $scope.order = { SWITCH_TO_RESERVE: 'N' };
  $resource(`${APIURL}/admin/orders/${$scope.order_no}`).get((data) => {
    $scope.original_order = data.order;
    
    $scope.order.JOB_TYPE = $scope.original_order.JOB_TYPE;    
    $scope.order.EXTRA_AMOUNT = $scope.original_order.EXTRA_AMOUNT;    
    $scope.order.EXTRA_AMOUNT_NOTE = $scope.original_order.EXTRA_AMOUNT_NOTE;    
    $scope.order.EXCLUDE_WASH_COUNT_YN = $scope.original_order.EXCLUDE_WASH_COUNT_YN == 'Y';
    $scope.order.EXCLUDE_CASH_COUNT_YN = $scope.original_order.EXCLUDE_CASH_COUNT_YN == 'Y';
        
    $scope.order.employee = { ID: data.order.TB_USER_ID_EMPLOYEE, NAME: data.order.EMPLOYEE_NAME, TEL: data.order.EMPLOYEE_TEL, ADDR: '' };
    $resource(`${APIURL}/admin/reservation/times`).get({ TIMEZONE: moment.tz.guess() }, (_data) => {
      $scope.times = _data.times;
      $scope.dates = [];
      $scope.hours = [];
      $scope.minutes = [];

      const orderStartDate = moment($scope.original_order.ORDER_START_DATE);
      let dateIdx = 0;
      let hourIdx = 0;
      let minIdx = 0;
      for (let idx = 0; idx < $scope.times.length; idx += 1) {
        const time = Object.keys($scope.times[idx])[0];
        const orderDate = moment(time, 'YYYYMMDD').format('YYYYMMDD');
        const _dateLocale = moment(time, 'YYYY년 MM월 DD일').format('LL');
        $scope.dates.push({ date: time, dateLocale: _dateLocale });
        if (idx === 0) {
          $scope.order.date = time;
        } else if (orderStartDate.format('YYYYMMDD') == orderDate) { // eslint-disable-line eqeqeq
          $scope.order.date = time;
          dateIdx = idx;
        }
      }
      for (let idx2 = 0; idx2 < $scope.times[dateIdx][$scope.order.date].length; idx2 += 1) {
        const hourDic = $scope.times[dateIdx][$scope.order.date][idx2];
        $scope.hours.push(Object.keys(hourDic)[0]);
        if (parseInt(Object.keys(hourDic)[0], 10) === orderStartDate.hour()) {
          hourIdx = idx2;
        }
      }
      $scope.order.hour = Object.keys($scope.times[dateIdx][$scope.order.date][hourIdx])[0];

      $scope.minutes = $scope.times[dateIdx][$scope.order.date][hourIdx][$scope.order.hour];
      for (let idx3 = 0; idx3 < $scope.times[dateIdx][$scope.order.date][hourIdx][$scope.order.hour].length; idx3 += 1) {
        const min = $scope.times[dateIdx][$scope.order.date][hourIdx][$scope.order.hour][idx3];
        if (min === orderStartDate.minute()) {
          minIdx = idx3;
        }
      }
      $scope.order.minute = `${$scope.minutes[minIdx]}`;
    }, (err) => {
      console.error(err);
      if (err.data && err.data.msg) {
        alert(err.data.msg);
      } else {
        alert($translate.instant('알수 없는 에러 입니다.'));
      }
    });
  }, (err) => {
    console.error(err);
    if (err.data && err.data.msg) {
      alert(err.data.msg);
    } else {
      alert($translate.instant('알수 없는 에러 입니다.'));
    }
  });

  $scope.changeOrderDate = () => {
    let targetIdx;
    for (let idx = 0; idx < $scope.dates.length; idx += 1) {
      if ($scope.order.date == $scope.dates[idx].date) { // eslint-disable-line eqeqeq
        targetIdx = idx;
        break;
      }
    }
    $scope.hours = [];
    $scope.minutes = [];
    for (let idx2 = 0; idx2 < $scope.times[targetIdx][$scope.order.date].length; idx2 += 1) {
      const hourDic = $scope.times[targetIdx][$scope.order.date][idx2];
      $scope.hours.push(Object.keys(hourDic)[0]);
    }
    $scope.order.hour = Object.keys($scope.times[targetIdx][$scope.order.date][0])[0];
    $scope.minutes = $scope.times[targetIdx][$scope.order.date][0][$scope.order.hour];
    $scope.order.minute = `${$scope.minutes[0]}`;
  };

  $scope.changeOrderHour = () => {
    let dateidx = 0;
    let houridx = 0;
    for (dateidx = 0; dateidx < $scope.dates.length; dateidx += 1) {
      if ($scope.order.date == $scope.dates[dateidx].date) { // eslint-disable-line eqeqeq
        break;
      }
    }
    for (houridx = 0; houridx < $scope.hours.length; houridx += 1) {
      if ($scope.order.hour === $scope.hours[houridx]) {
        break;
      }
    }
    $scope.minutes = $scope.times[dateidx][$scope.order.date][houridx][$scope.order.hour];
    $scope.order.minute = `${$scope.minutes[0]}`;
  };

  // 테크니션 검색
  $scope.openEmployees = () => {
    $resource(`${APIURL}/admin/employees/available`).get((data) => {
      $scope.employeeSearch = { query: '', result: data.employees };
      jQuery('#modal-2').modal('show');
    }, (err) => {
      console.error(err);
      if (err.data && err.data.msg) {
        alert(err.data.msg);
      } else {
        alert($translate.instant('알수 없는 에러 입니다.'));
      }
    });
  };
  $scope.searchEmployee = () => {
    $resource(`${APIURL}/admin/employees/available`).get({ q: $scope.employeeSearch.query, count: -1 }, (data) => {
      $scope.employeeSearch.result = data.employees;
    }, (err) => {
      console.error(err);
      if (err.data && err.data.msg) {
        alert(err.data.msg);
      } else {
        alert($translate.instant('알수 없는 에러 입니다.'));
      }
    });
  };
  $scope.selectEmployee = (user) => {
    $scope.order.employee = user;
    jQuery('#modal-2').modal('hide');
  };

  $scope.isLoading = false;
  $scope.submit = () => {
    if ($scope.isLoading) {
      return;
    }
    if ($scope.order.employee === undefined) {
      alert($translate.instant('테크니션을 선택해주세요.'));
      return;
    }


    if ($scope.original_order.ORDER_TYPE === 1) {
      const newOrderDateTxt = moment($scope.order.date, 'YYYY년 MM월 DD일').format('LL');
      if (confirm(`${$translate.instant('**예약세차수정**\n\n예약시간')} : ${moment.tz($scope.original_order.ORDER_START_DATE_UTC, moment.tz.guess()).format('LLL')} -> ${newOrderDateTxt} ${$scope.order.hour}:${$scope.order.minute}\n${$translate.instant('테크니션')} : ${$scope.original_order.EMPLOYEE_NAME} -> ${$scope.order.employee.NAME}\n\n${$translate.instant('수정하시겠습니까?')}`) === false) {
        return;
      }
      $scope.isLoading = true;
      $resource(`${APIURL}/admin/orders/${$scope.original_order.ORDER_NO}/reserved`).save({
        TB_USER_ID_EMPLOYEE: $scope.order.employee.ID,
        DATE: moment($scope.order.date, 'YYYY년 MM월 DD일').format('YYYYMMDD'),
        HOUR: $scope.order.hour,
        MINUTE: $scope.order.minute,
        TIMEZONE: moment.tz.guess(),
      }, (data) => {
        $scope.isLoading = false;
        alert($translate.instant('주문이 수정 되었습니다.'));
        if ($scope.user_id) {
          $location.path(`/member/${$scope.user_id}/wash/history`);
        } else {
          $location.path(`/orders/${$scope.menu}`);
        }
      }, (err) => {
        $scope.isLoading = false;
        console.error(err);
        if (err.data && err.data.msg) {
          alert(err.data.msg);
        } else {
          alert($translate.instant('알수 없는 에러 입니다.'));
        }
      });
    } else {
      if ($scope.order.SWITCH_TO_RESERVE === 'N') {
        if (confirm(`${$translate.instant('**바로세차수정**\n\n테크니션')} : ${$scope.original_order.EMPLOYEE_NAME} -> ${$scope.order.employee.NAME}\n\n${$translate.instant('수정하시겠습니까?')}`) === false) {
          return;
        }
      } else {
        const newOrderDateTxt = moment($scope.order.date, 'YYYY년 MM월 DD일').format('LL');
        if (confirm(`${$translate.instant('**예약세차수정**\n\n예약시간')} : ${newOrderDateTxt} ${$scope.order.hour}:${$scope.order.minute}\n${$translate.instant('테크니션')} : ${$scope.original_order.EMPLOYEE_NAME} -> ${$scope.order.employee.NAME}\n\n${$translate.instant('수정하시겠습니까?')}`) === false) {
          return;
        }
      }
      
      $scope.isLoading = true;
      $resource(`${APIURL}/admin/orders/${$scope.original_order.ORDER_NO}/direct`).save({
        TB_USER_ID_EMPLOYEE: $scope.order.employee.ID,
        SWITCH_TO_RESERVE: $scope.order.SWITCH_TO_RESERVE,
        DATE: $scope.order.date,
        HOUR: $scope.order.hour,
        MINUTE: $scope.order.minute,
        TIMEZONE: moment.tz.guess(),
        EXTRA_AMOUNT: $scope.order.EXTRA_AMOUNT,
        EXTRA_AMOUNT_NOTE: $scope.order.EXTRA_AMOUNT_NOTE,
      }, () => {
        $scope.isLoading = false;
        alert($translate.instant('주문이 수정 되었습니다.'));
        if ($scope.user_id) {
          $location.path(`/member/${$scope.user_id}/wash/history`);
        } else {
          $location.path(`/orders/${$scope.menu}`);
        }
      }, (err) => {
        $scope.isLoading = false;
        console.error(err);
        if (err.data && err.data.msg) {
          alert(err.data.msg);
        } else {
          alert($translate.instant('알수 없는 에러 입니다.'));
        }
      });
    }
  };
});

function handlePushMessage({ MESSAGE_TYPE, MESSAGE }) {
  let pushMessage = '세차가 취소되었습니다.';
  if (MESSAGE_TYPE === '0') {
    pushMessage = '세차가 취소되었습니다.';
  } else if (MESSAGE_TYPE === '1') {
    pushMessage = '고객님의 주문이 노쇼(no-show)로 인해 취소되었습니다. 해당 취소 사유는 결제금액이 환불되지 않습니다.';
  } else if (MESSAGE_TYPE === '2') {
    pushMessage = MESSAGE;
  }
  return pushMessage;
}



// WEBPACK FOOTER //
// ./src/app/orders/orders.js